// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2ec3B","large":"styles_large__r6UJt"};